import { useQuery } from 'react-query';
import { Release, ReleaseQueryParams } from '@repo/types/release';
import { httpClient } from '../../../utils/http/http-client';

export const useGetRelease = (
  id: number | undefined,
  query?: ReleaseQueryParams,
) =>
  useQuery(
    ['getRelease', query],
    () => httpClient.GET<ReleaseQueryParams, Release>(`release/${id}`, query),
    { enabled: Boolean(id) },
  );
